<template>
  <div>
    <!-- <h1 class="m&#45;label">地図 {{ maptutors }}</h1> -->
    <!-- <div class="form"> -->
    <!--   <label>出発地 -->
    <!--     <input type="text" id="from" value="国際センター駅（愛知）"> -->
    <!--   </label> -->
    <!--   <span>&#38;rarr;</span> -->
    <!--   <label>到着地 -->
    <!--     <input type="text" id="to" value="五条街園"> -->
    <!--   </label> -->
    <!--   <input type="button" id="btn" value="ルートを表示"> -->
    <!-- </div> -->

    <div style="display: flex;">

      <my-map
        class="my-map"
        :markers='markers'
        :tutors='maptutors'
        >
      </my-map>

      <!-- <gmap&#45;map -->
      <!--   :center="center" -->
      <!--   :zoom="15" -->
      <!--   style="width: 100%; height: 600px" -->
      <!-- > -->
      <!--   <gmap&#45;marker -->
      <!--     v&#45;for="(m, index) in markers" -->
      <!--     :key="index" -->
      <!--     :position="m.position" -->
      <!--     :clickable="true" -->
      <!--     :draggable="true" -->
      <!--     @click="center=m.position" -->
      <!--   > -->
      <!--   </gmap&#45;marker> -->
      <!-- </gmap&#45;map> -->

      <!-- <gmap&#45;street&#45;view&#45;panorama class="pano" :position="center" :zoom="1"> -->
      <!-- </gmap&#45;street&#45;view&#45;panorama> -->
    </div>

  </div>
</template>

<script>
import MyMap from '@/components/util/MyMap.vue'

export default {
  data () {
    return {
    }
  },

  computed: {
    lat () {
      return Number(this.$store.getters.tutor.lat)
    },

    lng () {
      return Number(this.$store.getters.tutor.lng)
    },

    lat2 () {
      return Number(this.$store.state.lat2)
    },

    lng2 () {
      return Number(this.$store.state.lng2)
    },

    center () {
      return { lat: this.lat, lng: this.lng }
    },

    markers () {
      return [{ position: { lat: this.lat, lng: this.lng } }]
    },

    // test
    tutors () {
      return this.$store.getters.tutors
    },

    maptutors () {
      return this.tutors.map(tutor => {
        if (tutor.lat !== null) {
          return { position: { lat: Number(tutor.lat), lng: Number(tutor.lng) } }
        } else {
          return
        }
      })
    }
    // markers () {
    //   return [{ position: { lat: this.lat, lng: this.lng } }, { position: { lat: this.lat2, lng: this.lng2 } }]
    // }
  },

  components: {
    MyMap
  }
}
</script>

<style lang="scss" scoped>
.pano {
  width: 500px;
  height: 300px;
}

.my-map {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// TutorMap.vue?a06972ac